import React from "react";
import {
  Avatar,
  Typography,
  Grid,
  Box,
  Paper,
  Stack,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Email } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import ComplianceScopeToggle from "./ComplianceScopeToggle";

const StaffHeader = ({
  staffMember,
  originalEmployee,
  refetch,
  onEditName,
  hasHrmsIntegration = false,
  optimisticInScope,
  onOptimisticScopeChange,
}) => {
  if (!staffMember) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        backgroundColor: "#f5f5f5",
        borderRadius: 0,
        borderBottom: "1px solid #e5e7eb",
      }}
    >
      <Grid container spacing={4} alignItems="flex-start">
        <Grid item>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              backgroundColor: "#031B89",
              fontSize: "2rem",
              fontWeight: 700,
            }}
          >
            {staffMember?.name
              ?.split(" ")
              ?.map((n) => n[0])
              ?.join("")}
          </Avatar>
        </Grid>
        <Grid item xs>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1 }}>
            <Typography
              variant="h4"
              fontWeight={700}
              sx={{ color: "#031B89" }}
            >
              {staffMember?.name}
            </Typography>
            {!hasHrmsIntegration && onEditName && (
              <Tooltip title="Edit Name" arrow>
                <IconButton
                  size="small"
                  onClick={onEditName}
                  sx={{
                    p: 0.25,
                    color: "#64748b",
                    "&:hover": { color: "#031B89", backgroundColor: "#f0f4ff" },
                  }}
                >
                  <EditIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
          <Stack direction="row" spacing={3} flexWrap="wrap" useFlexGap>
            <Box display="flex" alignItems="center" gap={1}>
              <Email fontSize="small" sx={{ color: "#64748b" }} />
              <Typography variant="body1" color="#64748b" fontWeight={500}>
                {staffMember?.email}
              </Typography>
            </Box>
            {/* {(staffMember?.role === "-" || staffMember?.manager === "-") && (
              <Button
                variant="outlined"
                size="small"
                onClick={() => setOpenClassifyDialog(true)}
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  color: '#031B89',
                  borderColor: '#031B89',
                  background: 'white',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                    borderColor: '#031B89'
                  }
                }}
              >
                Classify as non-employee
              </Button>
            )} */}
          </Stack>
        </Grid>
        <Grid item sx={{ flexShrink: 0, ml: "auto" }}>
          <ComplianceScopeToggle
            staffMember={staffMember}
            originalEmployee={originalEmployee}
            refetch={refetch}
            hasHrmsIntegration={hasHrmsIntegration}
            optimisticInScope={optimisticInScope}
            onOptimisticScopeChange={onOptimisticScopeChange}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default StaffHeader;
